import { RouteEnum } from '@/constants/enums/RouteEnum';
import type {
  NavigationGuardNext,
  NavigationGuardReturn,
  RouteLocationNormalized,
  Router
} from 'vue-router';

/**
 * 免費會員無法進入付費會員可用功能頁面
 * @param _context - 中介函式參數物件
 * @remarks 僅在使用者已登入時檢查，避免影響未登入的可瀏覽頁面
 */
export default function paid(_context: {
  to: RouteLocationNormalized;
  from: RouteLocationNormalized;
  next: NavigationGuardNext;
  router?: Router;
}): NavigationGuardReturn | void {
  const userStore = useUserStore();
  const isPaidFeatureDenied = !userStore.isPayUser;

  if (isPaidFeatureDenied) {
    return { name: RouteEnum.Index };
  }

  return;
}
